// extracted by mini-css-extract-plugin
export var md = "_2q-4";
export var semantic = "_2q-5";
export var sm = "_2q-3";
export var text = "_2q-6";
export var toggleInput = "_2q-0";
export var toggleSwitch = "_2q-1";
export var xs = "_2q-2";